<template>
  <AuthLayout :heading="$t(isSetPassword ? 'setPassword' : 'resetPassword')">
    <VForm v-model="isFromValid">
      <EmailInput
        v-model="email"
        @keydown.enter="submit"
      />

      <PasswordPair
        v-if="isWaitingForReset"
        @validPasswordPair="newPw => password = newPw"
        @invalidPasswordPair="password = ''"
        @submit="submit"
      />

      <VProgressLinear
        v-else
        :indeterminate="true"
      />
    </VForm>
    <template slot="action">
      <VBtn
        :disabled="isFormEmpty || !isFromValid"
        flat
        @click="submit"
      >
        {{ $t(isSetPassword ? 'setPassword' : 'resetPassword') }}
      </VBtn>
    </template>
  </AuthLayout>
</template>

<script>
import UserApi from '@/api/UserApi'
import EmailInput from '@/components/global-components/inputs/EmailInput.vue'
import PasswordPair from '@/components/global-components/inputs/PasswordPair.vue'
import AuthLayout from '@/components/layouts/AuthLayout'
import { mapActions } from 'vuex'

export default {
  name: 'PasswordReset',
  components: { AuthLayout, EmailInput, PasswordPair },
  props: [],
  data () {
    return {
      isFromValid: false,
      email: '',
      password: '',
      isWaitingForReset: true
    }
  },
  computed: {
    isFormEmpty () {
      return !this.email.trim() || !this.password.trim()
    },
    isSetPassword () {
      return this.$route.name === 'setPassword'
    }
  },
  methods: {
    ...mapActions('user', ['setUser']),
    async submit () {
      if (this.isFromValid) {
        try {
          this.isWaitingForReset = false
          const token = this.$route.query['token']

          const authObj = await UserApi.resetPassword({
            email: this.email,
            password: this.password,
            password_confirmation: this.password,
            token
          })

          UserApi.makeAuth(authObj)

          this.setUser(authObj.user)
          this.$router.push({ name: 'login' })
          this.$notification({
            success: {
              message: [this.$t('passwordChangedAndYouLoggedIn')]
            }
          })
        } catch (e) {
          this.isWaitingForReset = true
          this.$notification(e)
        }
      }
    }
  },
  i18n: {
    messages: {
      de: {
        passwordChangedAndYouLoggedIn: 'Sie haben Ihr Passwort geändert und sind nun angemeldet',
        setPassword: 'Passwort setzen',
        resetPassword: 'Passwortreset',
      },
      en: {
        passwordChangedAndYouLoggedIn: 'Your password has been changed and you are logged in',
        setPassword: 'Set password',
        resetPassword: 'Reset password',
      }
    }
  }
}
</script>
